import { render, staticRenderFns } from "./PaymentUnknownCard.vue?vue&type=template&id=5fd2ec4c"
var script = {}
import style0 from "./PaymentUnknownCard.vue?vue&type=style&index=0&id=5fd2ec4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports